<template>
  <div>
    <list row-key="id" ref="list" unit="打印日志" :page="page" :query-params="params" :show-query="showQuery"
      :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="店铺名称" label-width="105px">
          <el-select v-model="mallId" @change="onMallChange" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.mallId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号" label-width="105px">
          <el-input v-model="params.orderSn" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="运单号" label-width="105px">
          <el-input v-model="params.waybillCode" placeholder="请输入运单号" clearable />
        </el-form-item>
        <el-form-item label="打印时间" label-width="105px">
          <range-picker :date="[params.startDate, params.endDate]"
            @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="orderSn" label="订单号" width="200px" />
        <el-table-column prop="waybillCode" label="运单号" width="150px" />
        <el-table-column prop="goodsCode" label="商品编号" width="120px" />
        <el-table-column prop="goodsName" label="商品名称" min-width="300px" />
        <el-table-column prop="spec" label="规格" min-width="200px" />
        <el-table-column prop="price" label="售价" width="120px" />
        <el-table-column prop="count" label="数量" width="120px" />
        <el-table-column prop="createTime" label="打印时间" width="160px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      pddApi: {
        logistics: require('@/api/pdd/logistics').default,
        printlog: require('@/api/pdd/printlog').default,
      },
      sysType: "",
      mallId: "", //店铺编号
      params: {
        orderSn: "",
        waybillCode: "",
        startDate: null,
        endDate: null,
      },
      companiesList: [],
    };
  },
  created() {
    this.sysType = localStorage.getItem("sys_type");
    var user_info = localStorage.getItem("user-info");
    if (user_info) {
      let user = JSON.parse(user_info);
      let malls = this.$store.state.user.mallList.filter(x => x.day >= 0 && x.mallId == user.mallId);
      if (malls.length > 0) this.mallId = malls[0].mallId;
    }
    this.getCompanies();
  },
  computed: {
    mallList() {
      return this.$store.state.user.mallList.filter(x => x.day >= 0);
    }
  },
  methods: {
    onMallChange() {
      this.params.快递公司 = "";
      this.companiesList = [];
      this.getCompanies();
    },
    getCompanies() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.companies(this.mallId).then(res => {
          if (!res.errorCode) this.companiesList = res.data;
          resolve(res);
        }).catch((err) => { })
      })
    },
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey({ ...params })
      return new Promise((resolve, reject) => {
        console.log("获取数据");
        this[this.sysType + "Api"].printlog.getLogs(params, this.mallId).then(res => {
          resolve(res)
        }).catch(err => {
          resolve({ Code: 1, data: [] })
        })
      })
    },
  },
};
</script>